import "./AboutUs.css"

function AboutUs() {
  return (
    <div id="about" className="aboutPageContainer">
        <h1 style={{  fontSize: "48px", textSizeAdjust: "8xl", color: "black", font: "thin"}}>
          About Us 
        </h1>
        <div className="aboutContentContainer">
          <div className="aboutContentImageContainer">
            <img src="assets/aboutus4.jpg" style={{maxWidth:"30vw", overflow:"hidden", margin:"20px", marginBottom:"0", borderRadius:"25px"}}/>
            <p style={{fontSize:"25pt", margin:"5%"}}>Our wonderful family!</p>
          </div>
          <div className="aboutContentSubcontainer">
            <p style={{justifyContent:"center", margin: "auto", fontSize:"28pt"}}>
              Fleming and Sons Home Improvement is a family-owned and operated private contracting company dedicated to providing quality contracting
              work to the greater east central Indiana area. We have extensive background in foundation repair and home re-leveling. We are committed
              to customer satisfaction.
            </p>
          </div>
        </div>
        <hr/>
        <div className="aboutContentContainer">
          <div className="aboutContentSubcontainer">
            <p style={{justifyContent:"center", margin: "auto", fontSize:"28pt"}}>
              Owner and proprietor Joseph Fleming has been living in and operating out of Muncie, IN for decades. He is supported both in his business operations 
              and in his personal life by his loving wife and his amazing kids. Some of their favorite family outing activities include fishing, hiking, and camping!
            </p>
          </div>
          <div className="aboutContentImageContainer">
            <img src="assets/aboutus5.jpg" style={{maxWidth:"30vw", overflow:"hidden", height: "75vh", margin:"20px", marginBottom:"0", borderRadius:"25px"}}/>
            <p style={{fontSize:"25pt", margin:"5%"}}>Joseph, his wife and Operations Manager Cel and his son Ike.</p>
          </div>
        </div>
        <hr/>
        <div className="aboutContentContainer">
          <div className="aboutContentImageContainer">
            <img src="assets/aboutus1.jpg" style={{maxWidth:"30vw", overflow:"hidden", height: "75vh", margin:"20px", marginBottom:"0", borderRadius:"25px"}}/>
            <p style={{fontSize:"25pt", margin:"5%"}}>Joseph's son, Web Designer Joseph VI, and daughter Iota.</p>
          </div>
          <div className="aboutContentSubcontainer">
            <p style={{justifyContent:"center", margin: "auto", fontSize:"28pt"}}>
              We take pride in our work as a family, and will stop at nothing to give you the home of your dreams. Call or email today, or use our Contact page to
              request an estimate. All local estimates are free.
            </p>
          </div>
        </div>
      <hr/>
    </div>
  )
}

export default AboutUs